<div class="ab-navbar-link-container">
  <a
    class="ab-navbar-link"
    *ngIf="project"
    (click)="select()"
    uiSref="project-errors"
    [uiParams]="{ projectId: project.id }"
    uiSrefActive="ab-navbar-link--active"
    [uiOptions]="{ inherit: false, reload: true }"
    title="Project errors"
  >
    <i class="ab-navbar-link__icon d-lg-none glyphicon glyphicon-bar-chart">
    </i>
    <span class="d-md-none d-lg-inline">Errors</span>
  </a>
</div>

<div class="ab-navbar-link-container">
  <a
    class="ab-navbar-link"
    *ngIf="project"
    (click)="select()"
    uiSref="project-deploys"
    [uiParams]="{ projectId: project.id }"
    uiSrefActive="ab-navbar-link--active"
    title="Project deploys"
  >
    <i class="ab-navbar-link__icon d-lg-none glyphicon glyphicon-flash"> </i>
    <span class="d-md-none d-lg-inline">Deploys</span>
  </a>
  <ab-onboarding-callout
    [className]="'AddDeploys'"
    [project]="project"
  ></ab-onboarding-callout>
</div>

<div class="ab-navbar-link-container">
  <a
    class="ab-navbar-link"
    *ngIf="project"
    (click)="select()"
    uiSref="project-performance"
    [uiParams]="{ projectId: project.id }"
    [uiOptions]="{ inherit: false }"
    uiSrefActive="ab-navbar-link--active"
    title="Project performance"
  >
    <i class="ab-navbar-link__icon d-lg-none glyphicon glyphicon-ab-gauge"> </i>
    <span class="d-md-none d-lg-inline">Performance</span>
  </a>
  <ab-onboarding-callout
    [className]="'AddApm'"
    [project]="project"
  ></ab-onboarding-callout>
</div>

<div class="ab-navbar-link-container">
  <a
    class="ab-navbar-link"
    *ngIf="project"
    (click)="select()"
    uiSref="project-trends"
    [uiParams]="{ projectId: project.id }"
    uiSrefActive="ab-navbar-link--active"
    title="Project trends"
  >
    <i class="ab-navbar-link__icon d-lg-none glyphicon glyphicon-line-chart">
    </i>
    <span class="d-md-none d-lg-inline">Trends</span>
  </a>
</div>

<div class="ab-navbar-link-container">
  <a
    class="ab-navbar-link"
    *ngIf="project && getexceptional"
    (click)="select()"
    uiSref="project-alerts"
    [uiParams]="{ projectId: project.id }"
    uiSrefActive="ab-navbar-link--active"
    title="Project alerts"
  >
    <i class="ab-navbar-link__icon d-lg-none glyphicon glyphicon-clock-o"> </i>
    <span class="d-md-none d-lg-inline">Alerts</span>&nbsp;
    <span class="badge badge-info badge-small">gx!</span>
  </a>
</div>

<div class="ab-navbar-link-container">
  <a
    class="ab-navbar-link"
    *ngIf="project"
    href="/projects/{{ project.id }}/services"
    title="Project integrations"
    target="_self"
  >
    <i class="ab-navbar-link__icon d-lg-none glyphicon glyphicon-laptop"> </i>
    <span class="d-md-none d-lg-inline">Integrations</span>&nbsp;
    <span class="badge badge-success badge--small">New!</span>
  </a>
  <ab-onboarding-callout
    [className]="'AddSlack'"
    [project]="project"
  ></ab-onboarding-callout>
</div>

<div class="ab-navbar-link-container">
  <a
    class="ab-navbar-link"
    *ngIf="project"
    href="/projects/{{ project.id }}/edit"
    title="Project settings"
    target="_self"
  >
    <i class="ab-navbar-link__icon d-lg-none glyphicon glyphicon-cog"> </i>
    <span class="d-md-none d-lg-inline">Settings</span>
  </a>
</div>
